export default {
  "111": "Download failed, please try again later!",
  "112": "The picture has been taken off the shelf!",
  "113": "Network congestion, please try again later!",
  "114": "AI Painting",
  "115": "Hot",
  "ede5ad04f7": "Whether to copy by hand",
  "f93d7233ea": "Buried point:",
  "7b317dc923": "Unburied point:",
  "ae336cd047": "Favorite",
  "934ebd87e6": "Favorited",
  "5442a970ed": "View Brief Review",
  "f93572dc20": "Brief comment",
  "0350555272": "Added to \"My Favorites\"",
  "5aa512fef5": "Go see",
  "21efd88b67": "No data",
  "81d76b746b": "Network connection failed",
  "6ab5f11fbd": "Illustrated data",
  "62a4a22dc0": "Please log in and bookmark!",
  "097e5cfa00": "Favorites failed, please log in again and try again!",
  "866b795eae": "Failed to load",
  "26b5bd4947": "Loading...",
  "2b496a8eac": "Already in the end",
  "9a79b39a1a": "No favorites",
  "975ff67ee1": "My collection",
  "cd11be8c92": "Please enter keywords",
  "625fb26b4b": "Cancel",
  "3ad3cfa11b": "Clear history",
  "da324a561e": "Confirm to delete all history?",
  "2f4aaddde3": "Delete",
  "d12f75264c": "No search content",
  "1c6e68c78d": "Reprinting must be marked with \"RoyalFlush iFinD\". The data source is marked in the picture. The individual stocks and industries involved in the content do not represent the views of the platform and do not constitute investment advice.",
  "35f414b9c2": "Recommend for you",
  "66ef92bbe5": "Please log in and bookmark",
  "f62827f0c4": "Favorites are successful!",
  "cb0f88686e": "Cancellation of favorites succeeded!",
  "b32b0111c1": "Favorites failed",
  "e8b9e5dda8": "Please log in and bookmark",
  "4233a27bd6": "No favorites",
  "a715bb174b": "Client call",
  "bfe4bd3c5e": "Client call failed",
  "6d596f3e1b": "Please call within the client",
  "8818d4830d": "Home",
  "0b6d2219c6": "Collection failed!",
  "a8b0c20416": "All",
  "0cd025fa": "What do you want to see",
  "12822ccb": "Let's draw"
}